/**
 * BrandHeader Component
 * Displays the brand logo, name, description, rating, and actions.
 */

import React from 'react';
import PropTypes from 'prop-types';
import { Box, Container } from '@mui/material';

import * as styles from './styles';
import BrandInfo from './components/BrandInfo';
import QuickFilters from './components/QuickFilters';

export const BrandHeader = ({ 
  brand, 
  // selectedFilter, 
  // onFilterChange
}) => {
  // const theme = useTheme();

  // const [isInfoOpen, setIsInfoOpen] = useState(false);

  // const handleInfoToggle = () => {
  // ... existing code ...

  return (
    <Container maxWidth="lg">
      {/* Apply styles directly */}
      <Box sx={styles.containerStyles}>
        <BrandInfo 
          brand={brand} 
          // Pass down brand data, subcomponent will handle responsiveness internally
          // deviceType={deviceType} // Removed
          // tabletType={tabletType} // Removed
        />
        
        <QuickFilters 
          // Add props if needed based on QuickFilters definition
        />
      </Box>
    </Container>
  );
};

BrandHeader.propTypes = {
  // Datos de la marca
  brand: PropTypes.shape({
    name: PropTypes.string.isRequired,
    logo: PropTypes.string,
    image: PropTypes.string,
    description: PropTypes.string,
    verified: PropTypes.bool,
    rating: PropTypes.number,
    reviewCount: PropTypes.number,
    location: PropTypes.string,
    categories: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
        name: PropTypes.string.isRequired
      })
    )
  }).isRequired,
  
  // Navegación
  // onBack: PropTypes.func.isRequired,
  
  // Filtros
  // filters: PropTypes.arrayOf(
  //   PropTypes.shape({
  //     id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  //     name: PropTypes.string.isRequired
  //   })
  // ),
  // selectedFilter: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  // onFilterChange: PropTypes.func,
  
  // Remove responsiveness props from PropTypes
  // deviceType: PropTypes.oneOf(['mobile', 'tablet', 'desktop']).isRequired,
  // tabletType: PropTypes.oneOf(['generic', 'iPadMini', 'iPadAir', 'iPadPro'])
};

BrandHeader.defaultProps = {
  // Remove unused props from defaultProps
  // onFilterChange: () => {},
  // filters: null,
  // selectedFilter: null
};

export default BrandHeader;
